@if (showNotification$ | async) {
  <div class="sh-notification--update">
    @if (notificationContent$ | async; as notificationContent) {
      <div class="sh-notification__content">
        @if (notificationContent.title) {
          <h4 class="sh-notification__title">
            <sh-html-parser [message]="notificationContent.title"></sh-html-parser>
          </h4>
        }
        <div class="sh-notification__msg">
          @for (paragraph of notificationContent.paragraphs; track paragraph) {
            <p>
              <sh-html-parser [message]="paragraph"></sh-html-parser>
            </p>
          }
        </div>
      </div>
    }
    <button type="button" class="sh-pure-icon-button sh-notification__close-button" aria-label="close" (click)="onClose()">
      <svg sh-icon class="sh-icon-button__icon" [name]="'close'"></svg>
    </button>
  </div>
}
